import { AssetSvgProps } from "../../../shared/assets"

function PlaInd019({ className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <g id="PlaInd019__Layer6_0_FILL">
                    <path
                        fill="url(#PlaInd019__Gradient_1)"
                        d="M113.05 197H45.9l-6.05 1.8-11.75 3.5h-1.2q-15.514.436-26.9 8.3v31.65h35L113.05 197m-41.55-7.6l-23.1 6.85h65.95l41.35-24h-17.85v7.05h-32.3l-16.65 4.95h-.1l-17.3 5.15m116.05-16.6l.5-.55h-10.1l-23.05 24h28.8l7.55-17.5v1.35l-6.8 16.15h49.25l-10.3-17.9v-1.25l11.2 19.15h25.8l-25.55-24h-8.15l.5.55h-.25l-3.55 1.8q-16.075 3.76-32.15 0l-3.5-1.8h-.2M385 242.25v-40.2L365.3 196v2.5h-22l-4.2-1.5H297l78.6 45.25h9.4m-48.05-46l-4.5-1.6v-3.15H314.8l-13.75-5.35v-7.55l-22.1-6.35H254l41.7 24h41.25m-153.6.75H154.2l-43.4 45.25h53L183.35 197m-67.95-.75h38.65l23.25-24h-20.65l-41.25 24m37.9.75h-39.2l-77.7 45.25h73.05L153.3 197m107.9 0h-26.15l26.4 45.25h47.9L261.2 197m34.65 0h-33.3l48.65 45.25h62.65l-78-45.25m-34.1-.75h32.8l-41.3-24H235.9l25.85 24m-27.65.75h-49.95l-19.05 45.25h94.95L234.1 197z"
                    />
                    <path
                        fill="#308185"
                        d="M85.45 173.45V100.9q-5.995-10.138-13.95-6.55v79.1h13.95m0-88v-27.5L71.5 47.45V77.7q7.857 10.492 13.95 7.75M181 125.5l-10.15-12.05v45.7l10.15-3.6V125.5m58.9-12.05l-12 12.05v30.25l12 3.95v-46.25m92.55-86.85V10.85l-13.25 13.2V39.6l13.25-13z"
                    />
                    <path
                        fill="#E1E1E1"
                        d="M156.65 159.8v-1.25H142.3v1.25h14.35m75.15 0l-7.35-4.25h-6.5l4.6 4.25h9.25m9.7.5h-8.25l19.85 11.45h24.1l-13.95-4v-4.65h-19.7v-2l-2.05-.8m-1.3-.5l-.3-.1-12-3.95-.65-.2H225l7.35 4.25h7.85m-63.9.5h-8.65l-1.7.6h-9.3v-.6H142.3v8.1l-4.45 1.3v2.05h18.7l19.75-11.45m13.05-.5l4.1-4.25h-8.15l-7.3 4.25h11.35m-4.85-4.25H181l-10.15 3.6-1.8.65h8.1l7.35-4.25m16.8 0h-7.35l-4.1 4.25h7.6l-.4.5h-7.65l-11 11.45h10l-.35.5-.5.55h.2l3.5 1.8q16.075 3.76 32.15 0l3.55-1.8h.25l-.5-.55-.45-.5h8.05l-12.2-11.45h-6.05l-.45-.5h6l-4.55-4.25h-6.2l1.6 2.7h-.55l-1.55-2.7h-8.75l-1.15 2.7h-.35l1.2-2.7m31.35 4.75h-9.6l12.35 11.45h17l-19.75-11.45m-54.9 11.45l11.1-11.45h-11.7l-19.65 11.45h20.25z"
                    />
                    <path
                        fill="#AEAEAE"
                        d="M156.65 160.3v-.5H142.3v.5h14.35m54.2-4.75h-.5l1.55 2.7h.55l-1.6-2.7m-9.25 0h-.3l-1.2 2.7h.35l1.15-2.7z"
                    />
                    <path
                        fill="#A4A4AE"
                        d="M114.7 158.25h-.15q-.5.1-1.1.5-.6.4-.55 1.35l-.05.15q-.6 0-1.05.1-.4.05-.7.2-1.3.55-1.3 2.05 0 .25.1 1.05-.4-.25-1.1-.25-1.7 0-2.6.8-.95.75-1.15 2.4h31.6q0-.9-.2-1.7-.4-1.45-1.25-1.8-.15-.1-.2-.2-.1-.1-.15-.1l-1-.3-1.4-.25h-.8q-.2-.25-.45-.65-.15-.25-.3-.45-.25-.4-.35-.45-.9-.7-1.4-.9-.6-.2-1.65-.35-.05-.25-.25-.6l-.2-.5q-.15-1.1-.45-1.6-.1-.2-.4-.3-.15-.15-.25-.2-.05-.05-.25-.1-.35-.1-.8-.25h-1.7q-.4.05-.8.4-.3.2-.45.35-.5-.7-1.05-1.05-1.15-.85-2.1-.85-1.5 0-2.1 1.05-.5.75-.65 2.6-.25 0-.7-.05-.45-.1-.65-.1M372.5 36.4l-7.2 5V196l19.7 6.05V36.4h-12.5m-109.25 119v-2.1q-.003-.106-.05-.2-.3-.8-.7-1.1-.4-.3-.8-.2-.15-.8-.45-1.15-.35-.35-1.1-.35h-.8q-.2.1-.65.5l-.1-.1q-.45-.9-.6-1.15-.25-.35-.95-.35-.8 0-1.65.55-.5.3-.9.7-.1-.3-.45-.65-.6-.6-1.35-.7-.15-.05-.3-.05-1.65 0-2.8 1.1-.6.55-.8.95l-.35-.25q-.65-.5-1-.5t-1 .65l-.1.1q-.65.7-.7.9-.15.5-.25 1.55-.1 1.1-.05 1.85h17.9m69.2 8.3q-.15-.15-.3-.25-2.15-1.7-3.7-1.7-1.35 0-1.95.65-.5-1.1-1.4-1.95-1.1-1.05-2.25-1.05-1.35 0-3.45 1.8l-.2.2q-1.8 1.65-2.05 1.85-.2-.25-1.45-.95-.05 0-.1-.05-1.45-.85-2-.85-.7 0-1.8.7-1.3.75-1.75 1-1.1-2.35-2.05-2.35-.1 0-.2.05-1.15.1-2.35 1.6-1.25 1.6-1.25 2.85 0 .9.3 1.6.6 1.25.65 1.4-.35.25-1.3.4-1.05.2-1.25.3v1.25l12.2 3.25h17.65v-9.75z"
                    />
                    <path
                        fill="#A2DDDD"
                        d="M156.65 112.45H142.3v42.6h14.35v-42.6z"
                    />
                    <path
                        fill="#999"
                        d="M127.1 140.85V139h-12.55v2h12.55v-.15z"
                    />
                    <path
                        fill="#437D7F"
                        d="M127.25 141H114.55v17.25h.15q.2 0 .65.1.45.05.7.05.15-1.85.65-2.6.6-1.05 2.1-1.05.95 0 2.1.85.55.35 1.05 1.05.15-.15.45-.35.4-.35.8-.4h1.7q.45.15.8.25.2.05.25.1.1.05.25.2.3.1.4.3.3.5.45 1.6l.2.5q.2.35.25.6 1.05.15 1.65.35.5.2 1.4.9.1.05.35.45.15.2.3.45.25.4.45.65h.8l1.4.25 1 .3q.05 0 .15.1v-45.45L114.55 108v31h12.55v1.85l.15.15z"
                    />
                    <path
                        fill="#3AA3A3"
                        d="M71.5 173.45v15.95l17.3-5.15h-3.35v-10.8H71.5z"
                    />
                    <path
                        fill="#B6FAE5"
                        d="M49.15 0h-9.3q7.213 99.4 0 198.8l6.05-1.8 2.5-.75 23.1-6.85V94.35q7.955-3.588 13.95 6.55v83.35h3.45l16.65-4.95h-1v-128L49.15 0m36.3 57.95v27.5q-6.093 2.742-13.95-7.75V47.45l13.95 10.5z"
                    />
                    <path
                        fill="#A55EBA"
                        d="M.2 70.65q-.096.141-.2.3v.5q.15-.45.2-.8z"
                    />
                    <path
                        fill="#BA730A"
                        d="M0 22.35Q9.074 33.238 27.6 39.4l.45 162.9h.05l11.75-3.5q7.213-99.4 0-198.8H0v22.35z"
                    />
                    <path
                        fill="#675027"
                        d="M27.6 39.4Q9.074 33.238 0 22.35v48.6q.104-.159.2-.3-.05.35-.2.8V210.6q11.386-7.864 26.9-8.3h1.15L27.6 39.4z"
                    />
                    <path
                        fill="#F1A7AF"
                        d="M111.8 77.35l26.05 19v73.35l4.45-1.3V86.2l-37.75-34.9v115.3h.5q.2-1.65 1.15-2.4.9-.8 2.6-.8.7 0 1.1.25-.1-.8-.1-1.05 0-1.5 1.3-2.05.3-.15.7-.2v-83z"
                    />
                    <path
                        fill="#CCC"
                        d="M137.85 96.35l-26.05-19v83q.45-.1 1.05-.1l.05-.15q-.05-.95.55-1.35.6-.4 1.1-.5V108l20.45 9.45v45.45q.05.1.2.2.85.35 1.25 1.8.2.8.2 1.7h-32.1v12.7h33.3V96.35M365.3 41.4l7.2-5 6.45-4.5 6.05-4.25V0H49.15l55.4 51.3 37.75 34.9v26.25h14.35v42.6H142.3v3.5h14.35v2.35h9.3l1.7-.6 1.4-.5 1.8-.65V107.7l69.05-.1v52.1l.3.1 1.3.5 2.05.8v2h19.7v4.65l13.95 4 1.75.5 22.1 6.35v7.55l13.75 5.35h17.65v3.15l4.5 1.6 2.15.75 4.2 1.5h22V41.4m-32.85-30.55V26.6l-13.25 13V24.05l13.25-13.2m-.3 152.6q.15.1.3.25v9.75H314.8l-12.2-3.25v-1.25q.2-.1 1.25-.3.95-.15 1.3-.4-.05-.15-.65-1.4-.3-.7-.3-1.6 0-1.25 1.25-2.85 1.2-1.5 2.35-1.6.1-.05.2-.05.95 0 2.05 2.35.45-.25 1.75-1 1.1-.7 1.8-.7.55 0 2 .85.05.05.1.05 1.25.7 1.45.95.25-.2 2.05-1.85l.2-.2q2.1-1.8 3.45-1.8 1.15 0 2.25 1.05.9.85 1.4 1.95.6-.65 1.95-.65 1.55 0 3.7 1.7m-103-141.5v-.05l.05-.15-.05.2m34.1 131.35v2.1h-17.9q-.05-.75.05-1.85.1-1.05.25-1.55.05-.2.7-.9l.1-.1q.65-.65 1-.65t1 .5l.35.25q.2-.4.8-.95 1.15-1.1 2.8-1.1.15 0 .3.05.75.1 1.35.7.35.35.45.65.4-.4.9-.7.85-.55 1.65-.55.7 0 .95.35.15.25.6 1.15l.1.1q.45-.4.65-.5h.8q.75 0 1.1.35.3.35.45 1.15.4-.1.8.2.4.3.7 1.1.047.094.05.2z"
                    />
                    <path
                        fill="#AAA"
                        d="M184.5 155.55H193.45V133.7h23.6v21.85h10.2l.65.2V125.5h-45.15v30.05h1.75M225.35 127v5.65h-40.3V127h40.3m-7.25 14.7h6.2v8.5h-6.2v-8.5m-31.9 0h6.2v8.5h-6.2v-8.5m38.1-9.95v-3.8h-38.2v3.8h38.2m-30.05 18.45v4.25h10.45v-4.25h-10.45m21.9 4.25v-4.25H205.7v4.25h10.45M204.7 141.7v-7.05h-10.45v7.05h10.45m11.45 0v-7.05H205.7v7.05h10.45z"
                    />
                    <path
                        fill="#9AC2D3"
                        d="M192.4 141.7h-6.2v8.5h6.2v-8.5m31.9 0h-6.2v8.5h6.2v-8.5m-30.05 8.5h10.45v-2.55h-10.45v2.55m21.9-2.55H205.7v2.55h10.45v-2.55m-11.45-1.15v-4.8h-10.45v4.8h10.45m1-4.8v4.8h10.45v-4.8H205.7z"
                    />
                    <path
                        fill="#5E5E5E"
                        d="M225.35 132.65V127h-40.3v5.65h40.3m-1.05-4.7v3.8h-38.2v-3.8h38.2m-30.85 27.6H217.05V133.7h-23.6v21.85m12.25-9.05v-11.85h10.45v11.85H205.7m-1-4.8v4.8h-10.45v-11.85h10.45v7.05m1 5.95h10.45v6.8H205.7v-6.8m-11.45 6.8v-6.8h10.45v6.8h-10.45m45.65-41v-5.85l-69.05.1v5.75L181 125.5h46.9l12-12.05z"
                    />
                    <path fill="gray" d="M182.75 125.5H181v30.05h1.75V125.5z" />
                    <path
                        fill="url(#PlaInd019__Gradient_2)"
                        d="M339.1 197l-2.15-.75H295.7l-41.7-24h24.95l-1.75-.5h-24.1l-19.85-11.45h8.25l-1.3-.5h-7.85l-7.35-4.25h-.55l7.35 4.25h-9.25l-4.6-4.25h-.9l4.55 4.25h-6l.45.5h6.05l12.2 11.45h-8.05l.45.5h8.15l25.55 24h-25.8l-11.2-19.15v1.25l10.3 17.9h-49.25l6.8-16.15v-1.35l-7.55 17.5h-28.8l23.05-24h10.1l.35-.5h-10l11-11.45h7.65l.4-.5h-7.6l4.1-4.25h-.5l-4.1 4.25H178l7.3-4.25h-.8l-7.35 4.25h-8.1l-1.4.5h8.65l-19.75 11.45h-18.7v.5h17.85l-41.35 24H48.4l-2.5.75h67.15L35 242.25H0v1.25h32.85L0 262.55v1.25l34.1-20.3h74.15L0 355.25V359l109.6-115.5h53.65l-54.9 127H0v2.5h107.25l-5.2 12h3.05l5.05-12H335.2l6.9 12h2.9l-7-12h47v-2.5h-48.5l-74.35-127h48.55l74.3 69.8v-2.75l-72.45-67.05H376l9 5.25v-1.1l-7.25-4.15H385v-1.25h-9.4L297 197h42.1m-150.25-36.7l-11.1 11.45H157.5l19.65-11.45h11.7m34.2 0h9.6l19.75 11.45h-17l-12.35-11.45m-38.9 36.7h49.95l25.95 45.25H165.1L184.15 197m110.4-.75h-32.8l-25.85-24h17.35l41.3 24m-32 .75h33.3l78 45.25H311.2L262.55 197m-27.5 0h26.15l48.15 45.25h-47.9L235.05 197m-120.95 0h39.2l-43.85 45.25H36.4L114.1 197m39.95-.75H115.4l41.25-24h20.65l-23.25 24m10.5 47.25h96.25l72.95 127H111.2l53.35-127M154.2 197h29.15l-19.55 45.25h-53L154.2 197z"
                    />
                    <path
                        fill="#82838E"
                        d="M378.95 31.9l-6.45 4.5H385v-4.5h-6.05z"
                    />
                </g>
                <g id="PlaInd019__Layer6_1_FILL">
                    <path
                        fill="#E1D7EC"
                        d="M240.65 60.8q-8.498-4.727-16.05 0v25.1h.8q-.386.663-.8 1.5v3h8v-3q-.414-.837-.85-1.5h.85v-6.05l8.05-19.05z"
                    />
                    <path
                        fill="#D8E8EB"
                        d="M199.45 58.65q-8.2-6.573-16.4 0V85.9h1.45q-.716.685-1.45 1.5v3h16.4v-3q-.579-.815-1.2-1.5h1.2V58.65m-16.4-12.9v3.55q8.2 6.467 16.4 0v-3.55h-16.4z"
                    />
                    <path
                        fill="#A4A4AE"
                        d="M173.85 39.1L163.2 0h-23.8l17 39.1h17.45m48.35-8.2h-.3q.153-.683.3-1.5V2.65q-15.4-2.476-30.8 0V29.4q.19.86.35 1.5h-.35v4.15h3V30.9h-.4q.21-.64.4-1.5V5.15h25.15V29.4q.07.817.15 1.5h-.15v4.15h2.65V30.9m27.6 8.2L267.15 0H243.6l-10 39.1h16.2z"
                    />
                    <path
                        fill="#FFF"
                        d="M172 13.2v1.15q4.74 7.058 7.3 9.8-2.094 2.89-5.55 8.6v2.3h11.8V30.9h-.8q.406-.627.8-1.5V13.2H172m8.55 17.7q.046-.088.05-.2.072.113.1.2h-.15z"
                    />
                </g>
                <g id="PlaInd019__Layer6_2_FILL">
                    <path
                        fill="#A4A4AE"
                        d="M142.3 158.55h14.35v-3.5H142.3v3.5m0-57.3v5.85h14.35v-5.85H142.3m-4.45-4.9l-26.05-19v83q.45-.1 1.05-.1l.05-.15q-.05-.95.55-1.35.6-.4 1.1-.5V108l20.45 9.45v45.45q.05.1.2.2.85.35 1.25 1.8.2.8.2 1.7h-32.1v12.7h33.3V96.35m4.45-10.15v11.35h31.55L115.35 0h-66.2l93.15 86.2m110.4 15.05v6h10.55v-6H252.7m-86.75 59.65l4.9-1.75V107.7l69.05-.1v52.1l3.65 1.4v2h19.7v-7.7H245.1v-54.15h-79.15v59.65m166.5-150.05V0h-41.8L232.6 97.55h30.65V85.9l44.55-48.45v-3.7l7.9-8.5V162.3q1.25.7 1.45.95.25-.2 2.05-1.85V24.05l13.25-13.2M365.3 187.8h-22v10.7h22v-10.7m-32.85 3.7v-18.05H314.8v18.05h17.65M365.3 41.4h-22v144.75h22V41.4M385 27.65V7.7l-41.7 32.9h23.2L385 27.65z"
                    />
                    <path
                        fill="#888"
                        d="M332.45 183.8l10.85 4h22v-1.65h-22l-10.85-3.7v1.35z"
                    />
                    <path fill="#82838E" d="M365.3 41.4l1.2-.8h-23.2v.8h22z" />
                </g>
                <g id="PlaInd019__Layer6_4_FILL">
                    <path
                        fill="#A84035"
                        d="M91.35 143.85q-.3 2.25.05 2.65h-.05l-.55 24.35q3.05-.15 4.25-.45 1.2-.3 2.7-.8.05-8.7.1-13.05.05-6.15.25-10.55.05-1 .1-1.95v-.35-.25l-6.85.4M93 145.1q-.048-.048-.15-.05H93v.05z"
                    />
                    <path
                        fill="#DA938B"
                        d="M96.6 132.5q-.05-1.55-.4-2.9-.057.7-.15 1.5-.902-.967-3.55-.7-.25 1-.85 6.95-.65 5.95-.3 6.5l6.85-.4q-.1-1.15-.8-5.65-.8-5.1-.8-5.3z"
                    />
                </g>
                <g id="PlaInd019__Layer6_7_FILL">
                    <path
                        fill="#9F4F2E"
                        d="M125.55 147.55q-.35-2.1-1.7-3.95-1.2-1.65-2.75-2.6h-6.55v17.25h.15q.2 0 .65.1.45.05.7.05.15-1.85.65-2.6.6-1.05 2.1-1.05.95 0 2.1.85.55.35 1.05 1.05.15-.15.45-.35.4-.35.8-.4h1.7q.45.15.8.25-.25-1.5-.15-3.55.2-3.75 0-5.05z"
                    />
                    <path
                        fill="#5C2E1B"
                        d="M130.9 147.05q-1.4-3.5-3.65-6.05h-6.15q1.55.95 2.75 2.6 1.35 1.85 1.7 3.95.2 1.3 0 5.05-.1 2.05.15 3.55.2.05.25.1.1.05.25.2.3.1.4.3.3.5.45 1.6l.2.5q.2.35.25.6 1.05.15 1.65.35.5.2 1.4.9.1.05.35.45v-14.1z"
                    />
                </g>
                <g id="PlaInd019__Layer6_8_FILL">
                    <path
                        fill="#77A310"
                        d="M178.2 128.2l-5.2-3.95v30.05l5.2-1.3v-24.8z"
                    />
                    <path
                        fill="#F1A957"
                        d="M236.8 158.7v-5.1h-4.25v3.15h-1.6l5.85 1.95z"
                    />
                    <path
                        fill="#F4CF3E"
                        d="M232.8 126.55h-.25v27.05h4.25v-30.5l-4 3.45z"
                    />
                </g>
                <g id="PlaInd019__Layer6_13_FILL">
                    <path
                        fill="#E9BF8D"
                        d="M365.3 169.4V196l19.7 6.05v-33.8q-.835.06-1.7.1-13.424.63-18 1.05z"
                    />
                    <path
                        fill="#A9DFCF"
                        d="M372.5 36.4l-7.2 5v128q4.576-.42 18-1.05.865-.04 1.7-.1V36.4h-12.5z"
                    />
                </g>
                <g id="PlaInd019__Layer5_0_FILL">
                    <path
                        fill="#732F1C"
                        d="M187.75 172.8l3.5 1.8q16.075 3.76 32.15 0l3.55-1.8h.25l-7.5-8.4h-1q-1.515-.575 0-1.15l-4.5-5h-15.6l-3.8 5 .6 1.15h-1.5l-6.15 8.2v.2z"
                    />
                    <path
                        fill="#394670"
                        d="M224.6 60.8h-3.2v25.1h3.2V60.8m-3.2 26.6v3h3.2v-3h-3.2m-21.95-28.75V85.9h4.75V60.8h-1.4v-2.15h-3.35m0 28.75v3h4.75v-3h-4.75m-25.6-7.05v5.55h9.2V58.65H164.7l9.15 21.7m0 7.05v3h9.2v-3h-9.2m9.2-38.1v-3.55H159.3l1.5 3.55h22.25m19.75 0v-3.55h-3.35v3.55h3.35z"
                    />
                    <path fill="#73321E" d="M221.4 90.4v-3h-17.2v3h17.2z" />
                    <path
                        fill="#8D3925"
                        d="M221.4 60.8h-17.2v25.1h17.2V60.8z"
                    />
                    <path
                        fill="#431C12"
                        d="M173.85 85.9v1.5h58.75v-1.5h-58.75m45.7-56.5h-45.8v1.5H233.6v-1.5H219.55z"
                    />
                    <path
                        fill="#A5E016"
                        d="M199.45 49.3H160.8l3.9 9.35h38.1V49.3h-3.35z"
                    />
                    <path
                        fill="#FF5300"
                        d="M202.8 45.75V60.8H240.65L247 45.75h-44.2z"
                    />
                    <path
                        fill="#C65614"
                        d="M185.55 30.9v4.15h5.85V30.9h-5.85m36.65 0v4.15h4.6V30.9h-4.6m4.6-17.7h9.6L239.45 0H172v13.2h13.55v16.2h5.85V2.65q15.4-2.476 30.8 0V29.4h4.6V13.2z"
                    />
                    <path
                        fill="#D9F9A8"
                        d="M196.6 35.05V30.9h-2.2v4.15h2.2m8.1 0h3V30.9h-3v4.15m12.35-4.15v4.15h2.5V30.9h-2.5m-6.15-9.3h6.15v7.8h2.5V5.15H194.4V29.4h2.2v-5h-1v-1.7h10.2v1.7h-1.1v5h3v-9.95h3.2v2.15z"
                    />
                    <path
                        fill="#96C0CC"
                        d="M179.95 32.75V30.9h-6.2v1.85h6.2M172 14.35v2.85l1.55 6.9.65-1.45q.55-.95.85-1.35.1.1.25.2.1.05.25.15.1 0 .3.05h.05q.1.05.3.05.2 0 .35-.05.35.6.9 1.75 1.6 3.55 1.6 4.1 0 .4-3.65 1.85h4.55V14.35H172z"
                    />
                    <path
                        fill="#D48BD2"
                        d="M175.9 21.7h-.05q-.2-.05-.3-.05-.15-.1-.25-.15-.15-.1-.25-.2-.3.4-.85 1.35l-.65 1.45.2.95v4.35h1.65q3.65-1.45 3.65-1.85 0-.55-1.6-4.1-.55-1.15-.9-1.75-.15.05-.35.05-.2 0-.3-.05m28.8 7.7v-5h-8.1v5h8.1m0 5.65V30.9h-8.1v4.15h8.1z"
                    />
                    <path fill="#4F0520" d="M172 0h-3.85L172 17.2V0z" />
                    <path
                        fill="#F0E3EA"
                        d="M233.6 30.9h-6.8v4.15h6.8V30.9m2.8-17.7h-9.6v16.2h6.8v-4.2l2.8-12m-7.25 8.7l.05-.15-.05.2v-.05z"
                    />
                    <path
                        fill="#5E6766"
                        d="M217.05 35.05V30.9h-9.35v4.15h9.35m0-13.45h-6.15v-2.15h-3.2v9.95h9.35v-7.8z"
                    />
                    <path fill="#838" d="M204.7 24.4h1.1v-1.7h-10.2v1.7h9.1z" />
                    <path
                        fill="#9E783F"
                        d="M372.6 188.5H385v-33.95h-19.7v31.25l7.3 2.7z"
                    />
                </g>
                <g id="PlaInd019__Layer4_0_FILL">
                    <path
                        fill="#147430"
                        d="M113.55 160.2q-.4 0-.7.05-.6 0-1.05.1-.4.05-.7.2-1.3.55-1.3 2.05 0 .25.1 1.05-.4-.25-1.1-.25-1.7 0-2.6.8-.95.75-1.15 2.4h30.5q-.3-.35-.5-.55-1.2-1.3-2.5-1.3-1.75.35-2.1.05-.45-.3-1-.85t-1.4-.55q-.85 0-1.85.2t-1.15.05q-.2-.15-1.4-1.35-1.2-1.2-1.9-1.2-1.35 0-2.4.7-.6.4-2.05 1.3-.2-.9-1.35-1.7-1-.7-1.45-1-.65-.1-.95-.2m149.7-4.8v-2.1q-.003-.106-.05-.2-.9-.1-1.05-.1-.45 0-1.6.35-1.05.35-1.1.35-.2 0-.8-.8-.6-.8-1.5-.8-1 0-1.3 1.1-.5-.15-1.55-.8-.85-.5-1.6-.55h-.05q-.7 0-1.75.65-1.05.6-1.4.6-.35 0-.8-.5-.5-.6-.75-.8-.2-.2-1.5-.8l-.1.1q-.65.7-.7.9-.15.5-.25 1.55-.1 1.1-.05 1.85h17.9m61.8 14.35q0-.1-.05-.1l-.1-.05q-.45-1.05-.45-1.45 0-.6-1.3-1.7-1.3-1.2-2.3-1.2-.8 0-1.65.35h-.2q-1.1.45-1.35 1-1.2-2.05-1.95-2.7-.05-.05-.05-.1-1.25-1.05-3.4-1.05-1.45 0-2.2.35-1.1-2.35-2.05-2.35-.1 0-.2.05-1.15.1-2.35 1.6-1.25 1.6-1.25 2.85 0 .9.3 1.6.6 1.25.65 1.4-.35.25-1.3.4-1.05.2-1.25.3v1.25l12.2 3.25h17.65v-4.75l-.55-.55q-1.35-1.05-3-1.05-2.95 0-3.85 2.65z"
                    />
                    <path
                        fill="#341310"
                        d="M91.35 143.85q-.3 2.25.05 2.65l6.7-.5q.05-1 .1-1.95v-.35-.25l-6.85.4m1.65 1.2v.05q-.048-.048-.15-.05H93z"
                    />
                    <path
                        fill="#36C0E2"
                        d="M96.2 129.6q-.7-3.3-2.5-5.8-.3 2.35-1.2 6.6.75.45.8.6 1.25 5.35 2.2 6.85.45-5.2.7-8.25z"
                    />
                    <path
                        fill="#A1E4B8"
                        d="M123.95 134.15V115.8h-9.4v18.35h9.4z"
                    />
                    <path fill="#A4A4AE" d="M0 153.4h11.3v-1.2H0v1.2z" />
                    <path
                        fill="#542D23"
                        d="M71.5 92.5v1.85l13.95 6.55h3.45l-17.4-8.4z"
                    />
                    <path
                        fill="#492659"
                        d="M21.75 50.45H0v2h19.7v72.7H0v2h21.75v-76.7z"
                    />
                    <path fill="#4C2F2B" d="M0 39.4h27.6L0 22.35V39.4z" />
                    <path
                        fill="#CCC"
                        d="M135 98.05l-20.45-14v21.6L135 115.4V98.05z"
                    />
                    <path
                        fill="#FF9"
                        d="M139.45 55.45q-2.35-.7-5.7-.7t-5.7.7q-2.35.65-2.35 1.6 0 .9 2.35 1.6 2.35.65 5.7.65t5.7-.65q2.35-.7 2.35-1.6 0-.95-2.35-1.6M153.1 74.2q-2-.5-4.8-.5-2.85 0-4.8.5-2 .55-2 1.3 0 .8 2 1.3 1.95.55 4.8.55 2.8 0 4.8-.55 1.95-.5 1.95-1.3 0-.75-1.95-1.3m-32.6-47.65q0-1.1-3.05-1.9-3-.8-7.3-.8t-7.35.8q-3 .8-3 1.9 0 1.1 3 1.85 3.05.8 7.35.8t7.3-.8q3.05-.75 3.05-1.85m38.25-10.85q1.4-.45 1.4-1.1 0-.7-1.4-1.15-1.4-.45-3.35-.45-1.95 0-3.35.45-1.4.45-1.4 1.15 0 .65 1.4 1.1 1.4.5 3.35.5 1.95 0 3.35-.5m19.9 97.1q.8-.25.8-.6t-.8-.6q-.75-.25-1.85-.25-1.05 0-1.85.25-.75.25-.75.6t.75.6q.8.3 1.85.3 1.1 0 1.85-.3m4.9 8.95q-.5.2-.5.4t.5.3q.6.2 1.4.2.75 0 1.3-.2.6-.1.6-.3 0-.2-.6-.4-.55-.1-1.3-.1-.8 0-1.4.1m.15-3.45q0-.35-.7-.6-.65-.25-1.6-.25-.95 0-1.65.25-.65.25-.65.6t.65.55q.7.3 1.65.3t1.6-.3q.7-.2.7-.55m39.6 3.65q0 .2.5.35.5.15 1.2.15t1.15-.15q.5-.15.5-.35 0-.2-.5-.35-.45-.15-1.15-.15t-1.2.15q-.5.15-.5.35m2.05-3.65q0 .35.7.55.7.3 1.65.3t1.6-.3q.7-.2.7-.55 0-.35-.7-.6-.65-.25-1.6-.25-.95 0-1.65.25t-.7.6m9.45-7.15q-.75-.25-1.75-.25t-1.75.25q-.7.25-.7.65 0 .3.7.6.75.25 1.75.25t1.75-.25q.7-.3.7-.6 0-.4-.7-.65m-71.55-19q1.45-.45 1.45-1.05 0-.6-1.45-1-1.4-.4-3.45-.4-2 0-3.45.4-1.45.4-1.45 1t1.45 1.05q1.45.4 3.45.4 2.05 0 3.45-.4m-.15-60.8q1-.3 1-.8 0-.45-1-.85-1-.3-2.35-.3t-2.35.3q-.95.4-.95.85 0 .5.95.8 1 .4 2.35.4t2.35-.4m75.75-28.7l.6-2.65H172v2.65h66.85m7.35 89.9q2 0 3.45-.4 1.45-.45 1.45-1.05 0-.6-1.45-1t-3.45-.4q-2.05 0-3.45.4-1.45.4-1.45 1t1.45 1.05q1.4.4 3.45.4m11.55-18.85q-2.85 0-4.85.5-1.95.55-1.95 1.3 0 .8 1.95 1.3 2 .55 4.85.55 2.8 0 4.8-.55 1.95-.5 1.95-1.3 0-.75-1.95-1.3-2-.5-4.8-.5m21.15-16.65q0-.95-2.35-1.6-2.35-.7-5.7-.7t-5.7.7q-2.35.65-2.35 1.6 0 .9 2.35 1.6 2.35.65 5.7.65t5.7-.65q2.35-.7 2.35-1.6m-29.05-25.7q.95-.35.95-.9t-.95-.9q-.9-.35-2.2-.35-1.3 0-2.25.35-.9.35-.9.9t.9.9q.95.4 2.25.4t2.2-.4m2.55-15.15q1.75 0 3-.5 1.25-.45 1.25-1.1 0-.7-1.25-1.15-1.25-.45-3-.45-1.8 0-3.05.45-1.25.45-1.25 1.15 0 .65 1.25 1.1 1.25.5 3.05.5m47.15 8.45q-3-.8-7.3-.8t-7.35.8q-3.05.8-3.05 1.9 0 1.1 3.05 1.85 3.05.8 7.35.8t7.3-.8q3.05-.75 3.05-1.85t-3.05-1.9z"
                    />
                    <path
                        fill="#9D5441"
                        d="M52.4 33.15l-12.55-9.4V198.8l12.55-3.75V33.15z"
                    />
                    <path
                        fill="#D172BE"
                        d="M104.55 72.25V51.3L49.15 0h-9.3v23.75l12.55 9.4 52.15 39.1z"
                    />
                    <path
                        fill="#308185"
                        d="M263.25 161.8v5.95l37.8 10.85v-7.55l-37.8-9.25M307.8 49.1V37.45L263.25 85.9v5.8l44.55-42.6z"
                    />
                    <path
                        fill="#212D67"
                        d="M263.25 129.4V152l44.55 1.85V113.4l-44.55 16m44.55-49.2V59.3l-44.55 38.25v12.7L307.8 80.2z"
                    />
                    <path
                        fill="#63C7C7"
                        d="M257.35 134.75h5.9V112.1h-5.9v22.65z"
                    />
                    <path
                        fill="#CAD2D7"
                        d="M216.15 154.45v-4.25H205.7v4.25h10.45m8.15.1v-4.35h-6.2v4.35h6.2m-38.1-4.35v4.35h6.2v-4.35h-6.2m8.05 0v4.25h10.45v-4.25h-10.45z"
                    />
                    <path
                        fill="#421A12"
                        d="M187.75 172.8v1.8h39.2v-1.8h-39.2m6.9-9.3v.9h24.05v-1.15h-23.9l-.15.25z"
                    />
                    <path
                        fill="#92DAF0"
                        d="M192.4 141.7v-7.1h-6.2v7.1h6.2m31.9-9.95v-3.8h-38.2v3.8h38.2m-19.6 9.95v-7.05h-10.45v7.05h10.45m1 0h10.45v-7.05H205.7v7.05m12.4-7.1v7.1h6.2v-7.1h-6.2z"
                    />
                    <path
                        fill="#9E1FAD"
                        d="M175.6 139h-.45q-.1.35-.4 4.05-.55 3.5-1.45 3.5-.05 0-.3-.2v7.95l3.55-.9q0-8.35-.95-14.4z"
                    />
                    <path
                        fill="#246463"
                        d="M173 124.25l5.2 3.95V153l.95-.25v-25.4L173 122v2.25m63.8-1.15v-2l-5.85 5.45v30.2h1.6v-30.2h.25l4-3.45z"
                    />
                    <path
                        fill="#2C3798"
                        d="M235.05 144.25h-2.5v9.35h2.5v-9.35z"
                    />
                    <path
                        fill="#546775"
                        d="M229.5 89.45q.05.65.15.95h2.95v-3h-3.1v2.05m1.3-19.85v.85q.1.35.65 1.05-.95 0-2.05 1.45-1 1.3-1 2.05-.3.65-.3 1.3v.65q.2.6.9.6 1.05 0 1.05-1.1l-.15-1.25q.15-.5.2-.65.05-.05.1-.15.3-.35 1.2-.8.15-.1.25-.15v1.45q-.2 1-1.15 3-.15.3-.6.75-.5.45-.75.75-.7.65-1.55 1.05-.6.3-.6.35 0 .25 1.5 2.1.75.95 1.5 1.85 0 .3-.25.7-.1.15-.15.45h3v-6.05l3.55-8.3-.1-.1q-.75-.4-1.05-.6.65-.8 1.15-1.4.2-.35.2-1.2 0-2.9-2.8-1.9-2.75 1-2.75 3.25m-34.5 20.8q0-.85.05-1.1v-1.9h-3v3h2.95m-7.65 0H190q.35-.3.25-3h-1.55q0 1.4-.05 3m-3-3v3h1.5q.1-1.65.3-3h-1.8m6-15.4v1.25q-.1 1.25-.8 4.95v.55q.2.45.95.45.45 0 .6-1.2.2-1.55.55-2.3V78q-.2 1.05-.2 2.75v.55q.15.35.6.45v4.15h3v-1.6q.1-.2.1-.4.1-.45.1-1.95v-.3q.3-.1.55-.2.5-.3.5-.6-.75-3.6-.95-4.65-.3-1.3-.3-2.3v-.65q.35.95.45 2.15 0 .3.25 1.1.15.7.15 1.1-.05.6.2 1.2.05.25.1.4.45-.05.65-.4.2-.3.1-.8l-.3-4.5q-.35-2.15-1.2-3.35-.75-1.05-.75-1.3 0-.15.55-.5.45-.5.45-1.45 0-2.3-2-2.3-2.1.1-2.1 2.1 0 .3.5 1.75-.2.15-.55.5-.6.6-1.05 1.85-.15.5-.15 1.2m-5.35-6.9q-2.05-.3-2.05 1.6 0 .8.45 1.95.5 1.1.5 1.8 0 2.9-.9 5.8t-.9 2.95l.4.85q.5.8 1 .8.25 0 .45-.7.2-.85.3-1.1.05.45.15 1.6.1 1.05-.05 1.65v3.6h2.1q.3-1.3.65-2.3.05 0 .05-.05.2.7.25 1.6v.75h1.55q0-2.45-.05-3.75-.9-4.35-.9-5.15 0-.4.45-1.2.35-.8.35-1.2 0-.95-.7-2.05-1.35-1.9-1.9-3.1.65-.6.75-.9.05-.1.05-.75 0-2.35-2-2.7m-10.45-43.4h.05q.1.05.3.05.2 0 .35-.05.65-.1 1.1-.6.4-.5.4-.95 0-2.35-1.75-2.65-1.75-.35-1.75 1.85 0 .05.1 1.2.15.5.4.75.1.1.25.2.1.05.25.15.1 0 .3.05m57.05 13.35q.05-.05.05-.1 0-.25-.2-1.15.45-.15.85-.25V30.9h-4q0 .6.05 1.15.05.4-.05 1.1 0 .65.5 1.05h.6q.5-.1.95-.15v.8q.05.1.05.2h1.2m-1.55-18.65q-2.25-.5-2.25 1.65 0 .6.05.7.1.2.7.7-1.6 1.8-1.6 3.75 0 .45.45 1.15.65.9 1.7.9.2 0 .3-.05-.2.7-.5 1.5-.55 1.3-.6 2.7h4v-4.2l.5-2.1q-.25-.75-.55-1.05-1.35-1.3-1.55-1.8-.1-.4-.2-.6 1.8-.1 1.8-1.4 0-1.35-2.25-1.85m-2.2 5.55v-.05l.05-.15-.05.2m.65 2.05q-.15-.5-.15-1.05 0-.7.45-1.8.25-.5.45-.85.05.65.15 1.55.15 1.35.15 2 0 .45-.05.95-.1-.15-.4-.25-.5-.15-.6-.55z"
                    />
                    <path
                        fill="#6B930F"
                        d="M221.4 64.5h-17.2v3.85h17.2V64.5z"
                    />
                    <path
                        fill="#8DE0E0"
                        d="M197.3 16.75v5.95h2.8v-5.95h-2.8m6.1 5.95v-3.6h-2v3.6h2z"
                    />
                    <path
                        fill="#374F31"
                        d="M191.4 9.85v-2.7H172v2.7h19.4m45.75 0l.65-2.7h-15.6v2.7h14.95z"
                    />
                    <path
                        fill="#4AC3CE"
                        d="M216.45 13.2V7.15H197.3v6.05h19.15z"
                    />
                    <path
                        fill="#2EA7A6"
                        d="M208.65 14.2v5.25h2.25v2.15h5.55v-3.4h-2.15v-2.6h-3.1v-1.4h-2.55z"
                    />
                    <path
                        fill="#FFF"
                        d="M384.35 180.35q-1.15-.05-1.15.8 0 .8 1.3.8.296 0 .5-.1v-1.35q-.253-.114-.65-.15m-5-.2v2.8h2.45q-.1-.15-.15-.25-.05-.1-.05-1 0-.8.5-1.55h-2.75m3.25-12.2h-3.25v2.3h2.35q.15-1.2.9-2.3z"
                    />
                    <path
                        fill="#A2A0A5"
                        d="M382.55 179.45q-.2.25-.35.5-.1.1-.1.2-.5.75-.5 1.55 0 .9.05 1 .05.1.15.25h3.2v-1.1q-.204.1-.5.1-1.3 0-1.3-.8 0-.85 1.15-.8.397.036.65.15v-2.15q-.126-.05-.25-.05-1.2 0-2.2 1.15z"
                    />
                    <path
                        fill="#E6E6E6"
                        d="M382.2 179.95q.15-.25.35-.5 1-1.15 2.2-1.15.124 0 .25.05v-4.75h-5.65v6.55h2.75q0-.1.1-.2m2.8-13.8v-5.9h-5.65v7.7h3.25q.1-.2.2-.3 1.017-1.261 2.2-1.5z"
                    />
                    <path
                        fill="#614F27"
                        d="M385 158.45v-.9h-12.4v-3h-7.3v31.25l7.3 2.7v-2.6H385v-.9h-10.85v-26.55H385z"
                    />
                    <path
                        fill="gray"
                        d="M385 170.25v-4.1q-1.183.239-2.2 1.5-.1.1-.2.3-.75 1.1-.9 2.3h3.3z"
                    />
                    <path
                        fill="#FFF7B3"
                        d="M332.15 163.45q.15.1.3.25V26.6l-13.25 13v121.8l.2-.2q2.1-1.8 3.45-1.8 1.15 0 2.25 1.05.9.85 1.4 1.95.6-.65 1.95-.65 1.55 0 3.7 1.7z"
                    />
                </g>
                <g id="PlaInd019__Layer4_1_FILL">
                    <path
                        fill="#FFF"
                        d="M16.3 103.65q1.8-1 2.3-1.9.45-.95-.15-1.05-.65-.15-2.1-.1-1.45 0-2.8.55-1.5.65-1.7 1.7.5-.15 1.1-.35 1.35-.5 1.65-.5.1 0 .6.3.55.3.65.45-1.4.8-3.2 2.15-.1.05-.15.1 2-.4 3.8-1.35m-8-46.3q.05-1.2-.8-1.3-.85-.1-2.45.75-2.15 1.15-2.75 1.35H.5q-.153-.051-.5-.25v4.85q.025.022.05.05l.2.2q.3.3.55.6 3.05 2.8 7.25 3.1H9.1q1.8 0 2.8-.45.75-.35.75-.75-.65-.2-1.55-1.05-1.7-1.7-2.9-5.2-.05-.2.1-1.9z"
                    />
                    <path
                        fill="#FAC6C0"
                        d="M5.35 94.55q-.65.4-1.3.7-1.3.65-2.7.95v.8q1.1 3.95 2 5.6 1.85 3.25 4.95 3.25 2.55 0 4.2-.85.05-.05.15-.1 1.8-1.35 3.2-2.15-.1-.15-.65-.45-.5-.3-.6-.3-.3 0-1.65.5-.6.2-1.1.35-.65.15-1.15.15-4.55 0-5.2-3.3-.05-2.75-.15-5.15m.9-20.75q-.6.1-.9.2-.1.05-.25.15-.05.2-.05.45 0 .65.85 1.35.45.35 1.95 1.35 4.05 2.65 4.4 2.65.45 0 .6-.35.45-.1.75-.6.25-.45.25-.9 0-1.2-.75-1.35-.4-.2-1.4.15-.65.2-1.05.35Q10 76.9 8.35 76q-1.3-1.5-2-2.1l-.1-.1z"
                    />
                </g>
                <g id="PlaInd019__Layer4_2_FILL">
                    <path
                        fill="#A55EBA"
                        d="M11.6 86.35q.75-1.8.75-2.45.05-.3 0-.6-.1-.6-.65-.6-.65.25-1.55.55-1.8.55-4.35.55-3.45 0-4.9-2.45-.8-1.4-.8-3 0-.9.3-1.85-.2-.32-.4-.85V96.3q.687.005 1.35-.1 1.4-.3 2.7-.95.65-.3 1.3-.7.35-.25.7-.55 1.7-1.35 3.2-3.45 1.4-1.95 2.35-4.2z"
                    />
                    <path
                        fill="#FAC6C0"
                        d="M.4 69.65q0-.6-.25-1-.073.067-.15.15v2.15q.104-.159.2-.3.2-.65.2-1z"
                    />
                    <path
                        fill="#A25B45"
                        d="M8.85 67q0-.1.05-.3h-.85q-4.2-.3-7.25-3.1-.25-.3-.55-.6-.13.074-.25.15v5.25q.086.11.15.25.25.4.25 1 0 .35-.2 1-.05.35-.2.8v4.2q.2.53.4.85.4.6 1.05.6 2.6-2.4 3.65-2.95.15-.1.25-.15.3-.1.9-.2.8-.1 2.1-.2 1.5-.15 2.25-1.15.25-.3.3-1.05v-.95q0-1.25-1-2.1-1.05-.9-1.05-1.35z"
                    />
                </g>
                <path
                    fill="#ECECEC"
                    d="M384.85 243.5h.15V0H0v227h-.3v158h385.15v-12h.15v-2.5h-.15v-57.35l.15.15v-2.75l-.15-.15v-61.75l.15.1v-1.1l-.15-.05v-4.1M229.15 21.95v-.05l.05-.15-.05.2m-41.4 150.65v.2h-.2l.2-.2m7.05-9.35l-.15.25v-.25h.15M127.1 141v-.15l.15.15h-.15z"
                    id="PlaInd019__Layer7_0_FILL"
                />
                <path
                    fill="url(#PlaInd019__Gradient_1)"
                    d="M260.8 243.5h-96.25l-53.35 127h222.55l-72.95-127M0 359v11.5h108.35l54.9-127H109.6L0 359m0 14v12h102.05l5.2-12H0m34.1-129.5L0 263.8v91.45L108.25 243.5H34.1m-1.25 0H0v19.05l32.85-19.05m303.65 127H385v-57.2l-74.3-69.8h-48.55l74.35 127m5.6 14.5l-6.9-12H110.15l-5.05 12h237m-4.1-12l7 12h40v-12h-47m47-124.25l-9-5.25h-63.45L385 310.55v-61.8m0-5.25h-7.25l7.25 4.15v-4.15z"
                    id="PlaInd019__Layer7_1_FILL"
                />
                <path
                    fill="#BD86E1"
                    d="M0 51.2v19.75q.104-.159.2-.3-.05.35-.2.8v54.65h20.75V51.2H0z"
                    id="PlaInd019__Layer6_3_FILL"
                />
                <path
                    fill="#81F5D1"
                    d="M88.9 100.9h-3.45v83.35h3.45V100.9m-3.45-42.95v27.5l3.45 1.95V60.5l-3.45-2.55z"
                    id="PlaInd019__Layer6_5_FILL"
                />
                <path
                    fill="#9D5441"
                    d="M71.5 77.7v16.65l13.95 6.55h3.45V87.4l-17.4-9.7m33.05-5.45l-4.45-3.3V180.9l5.45-1.6h-1V72.25z"
                    id="PlaInd019__Layer6_6_FILL"
                />
                <path
                    fill="#308185"
                    d="M156.65 107.1H142.3v5.35h14.35v-5.35m100.7 5h5.9v-4.85H252.7v41.85q.75.1 1.35.7.35.35.45.65.4-.4.9-.7.85-.55 1.65-.55.7 0 .95.35.15.25.6 1.15l.1.1q.45-.4.65-.5h.8q.75 0 1.1.35.3.35.45 1.15.4-.1.8.2.4.3.7 1.1.047.094.05.2v-18.55h-5.9V112.1z"
                    id="PlaInd019__Layer6_9_FILL"
                />
                <path
                    fill="#0C411C"
                    d="M113.45 158.75q-.6.4-.55 1.35l-.05.15q-.6 0-1.05.1-.4.05-.7.2-1.3.55-1.3 2.05 0 .25.1 1.05-.4-.25-1.1-.25-1.7 0-2.6.8-.95.75-1.15 2.4h31.6q0-.9-.2-1.7-.4-1.45-1.25-1.8-.15-.1-.2-.2-.1-.1-.15-.1l-1-.3-1.4-.25h-.8q-.2-.25-.45-.65-.15-.25-.3-.45-.25-.4-.35-.45-.9-.7-1.4-.9-.6-.2-1.65-.35-.05-.25-.25-.6l-.2-.5q-.15-1.1-.45-1.6-.1-.2-.4-.3-.15-.15-.25-.2-.05-.05-.25-.1-.35-.1-.8-.25h-1.7q-.4.05-.8.4-.3.2-.45.35-.5-.7-1.05-1.05-1.15-.85-2.1-.85-1.5 0-2.1 1.05-.5.75-.65 2.6-.25 0-.7-.05-.45-.1-.65-.1h-.15q-.5.1-1.1.5m149.8-3.35v-2.1q-.003-.106-.05-.2-.3-.8-.7-1.1-.4-.3-.8-.2-.15-.8-.45-1.15-.35-.35-1.1-.35h-.8q-.2.1-.65.5l-.1-.1q-.45-.9-.6-1.15-.25-.35-.95-.35-.8 0-1.65.55-.5.3-.9.7-.1-.3-.45-.65-.6-.6-1.35-.7-.15-.05-.3-.05-1.65 0-2.8 1.1-.6.55-.8.95l-.35-.25q-.65-.5-1-.5t-1 .65l-.1.1q-.65.7-.7.9-.15.5-.25 1.55-.1 1.1-.05 1.85h17.9m69.2 18.05v-9.75q-.15-.15-.3-.25-2.15-1.7-3.7-1.7-1.35 0-1.95.65-.5-1.1-1.4-1.95-1.1-1.05-2.25-1.05-1.35 0-3.45 1.8l-.2.2q-1.8 1.65-2.05 1.85-.2-.25-1.45-.95-.05 0-.1-.05-1.45-.85-2-.85-.7 0-1.8.7-1.3.75-1.75 1-1.1-2.35-2.05-2.35-.1 0-.2.05-1.15.1-2.35 1.6-1.25 1.6-1.25 2.85 0 .9.3 1.6.6 1.25.65 1.4-.35.25-1.3.4-1.05.2-1.25.3v1.25l12.2 3.25h17.65z"
                    id="PlaInd019__Layer6_10_FILL"
                />
                <path
                    fill="#CCC"
                    d="M11.3 147.7H0v62.9q11.386-7.864 26.9-8.3l-15.6-.1v-54.5z"
                    id="PlaInd019__Layer6_11_FILL"
                />
                <path
                    fill="#DBEF87"
                    d="M27.95 202.3l-16.65-.1v2.5H0v5.9l27.95-8.3z"
                    id="PlaInd019__Layer6_12_FILL"
                />
                <path
                    fill="#907256"
                    d="M191.25 174.6v7.25h32.15v-7.25h-32.15z"
                    id="PlaInd019__Layer5_1_FILL"
                />
                <linearGradient
                    id="PlaInd019__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={192.5}
                    y1={187.475}
                    x2={192.5}
                    y2={378.425}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#E1E1E1" />
                    <stop offset="100%" stopColor="#FFF" />
                </linearGradient>
                <linearGradient
                    id="PlaInd019__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    x1={192.5}
                    y1={371.975}
                    x2={192.5}
                    y2={165.025}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#E1E1E1" />
                    <stop offset="100%" stopColor="#AAA" />
                </linearGradient>
            </defs>
            <use xlinkHref="#PlaInd019__Layer7_0_FILL" />
            <use xlinkHref="#PlaInd019__Layer7_1_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_0_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_1_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_2_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_3_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_4_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_5_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_6_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_7_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_8_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_9_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_10_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_11_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_12_FILL" />
            <use xlinkHref="#PlaInd019__Layer6_13_FILL" />
            <use xlinkHref="#PlaInd019__Layer5_0_FILL" />
            <use xlinkHref="#PlaInd019__Layer5_1_FILL" />
            <use xlinkHref="#PlaInd019__Layer4_0_FILL" />
            <use xlinkHref="#PlaInd019__Layer4_1_FILL" />
            <use xlinkHref="#PlaInd019__Layer4_2_FILL" />
        </g></g>
    )
}

export default PlaInd019
